import { defaultColDef } from "../defaultColDef";
import { ColDef } from "ag-grid-community";

export default function useDataProcess() {
    const inferType = (value: any): string => {
        if (value === null || value === undefined) return "null";
        if (Array.isArray(value)) return "array";
        return typeof value;
    };

    const formatHeader = (key: string): string =>
        key
            .replace(/_/g, " ") // snake_case → space
            .replace(/([a-z\d])([A-Z])/g, "$1 $2") // camelCase / PascalCase → space
            .replace(/\b\w/g, (l) => l.toUpperCase());

    const processInitialData = (data: any[]): ColDef[] => {
        if (!data || data.length === 0) return [];

        const typeMap: Record<string, string> = {};

        // Collect all unique keys and infer types
        data.forEach((item) => {
            Object.entries(item).forEach(([key, value]) => {
                if (!typeMap[key] && value !== null && value !== undefined) {
                    typeMap[key] = inferType(value);
                }
            });
        });

        const columnDefs: ColDef[] = Object.keys(typeMap).map((key) => ({
            headerName: formatHeader(key),
            field: key,
            sortable: true,
            filter: true,
            resizable: true,
            cellDataType: typeMap[key], // Custom or AG Grid compatible field
            // You can optionally add valueFormatter, filterType, etc. here based on type
        }));

        return columnDefs;
    };

    return { processInitialData };
}
